var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroll-to-top-component"},[_c('button',{staticClass:"btn btn-plain btn-plain-wicon",attrs:{"type":"button"},on:{"click":_vm.scrollTo}},[_c('md-icon',[_vm._v("keyboard_arrow_up")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }